// RankridgeLanding.tsx
import React from "react";
import { Helmet } from "react-helmet-async";
import BannerCarouselWithCourses from "./bannerscarosuel";
import AcademicPrograms from "./rankridgegrades";
import CourseGrid from "./coursegrid";
import FeatureCards from "./FeatureCards";
import RankridgeFAQTease from "./newfag";
import Testimonials from "./reviews";

export default function RankridgeLanding() {
  const brand = {
    name: "Rankridge",
    url: "https://www.rankridge.in",
    logo: "https://www.rankridge.in/logo.png",
    phone: "+91-90000-00000",
  };

  const faq = [
    {
      q: "What programs does Rankridge offer?",
      a: "Intermediate (MPC/BiPC), IIT-JEE (Mains & Advanced), and NEET long-term + crash courses.",
    },
    {
      q: "Do you provide weekly tests and analytics?",
      a: "Yes. Weekly/Monthly exams with detailed performance analytics and personal mentoring.",
    },
    {
      q: "Is hostel/transport available?",
      a: "Yes. Separate hostels, hygienic food, and GPS-enabled transport for select branches.",
    },
  ];

  // ------ JSON-LD helpers ------
  const jsonLd = {
    org: {
      "@context": "https://schema.org",
      "@type": "EducationalOrganization",
      name: brand.name,
      url: brand.url,
      logo: brand.logo,
      telephone: brand.phone,
      sameAs: [
        "https://www.facebook.com/rankridge",
        "https://www.instagram.com/rankridge",
        "https://www.youtube.com/@rankridge",
      ],
      address: {
        "@type": "PostalAddress",
        addressLocality: "Hyderabad",
        addressRegion: "Telangana",
        addressCountry: "IN",
      },
    },
    website: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      url: brand.url,
      name: "Rankridge Official Website",
      potentialAction: {
        "@type": "SearchAction",
        target: `${brand.url}/search?q={query}`,
        "query-input": "required name=query",
      },
    },
    breadcrumb: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: brand.url },
        {
          "@type": "ListItem",
          position: 2,
          name: "Courses",
          item: `${brand.url}/courses`,
        },
      ],
    },
    courses: [
      {
        "@context": "https://schema.org",
        "@type": "Course",
        name: "Intermediate (MPC/BiPC) with Integrated Coaching",
        description:
          "Two-year junior college program with integrated IIT-JEE / NEET preparation.",
        provider: { "@type": "EducationalOrganization", name: brand.name },
      },
      {
        "@context": "https://schema.org",
        "@type": "Course",
        name: "IIT-JEE Mains & Advanced",
        description:
          "Long-term classroom program with concept-centric teaching and weekly mock tests.",
        provider: { "@type": "EducationalOrganization", name: brand.name },
      },
      {
        "@context": "https://schema.org",
        "@type": "Course",
        name: "NEET Long-Term",
        description:
          "Full-year program focused on NCERT mastery, concept retention, and rank-oriented practice.",
        provider: { "@type": "EducationalOrganization", name: brand.name },
      },
    ],
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faq.map(({ q, a }) => ({
        "@type": "Question",
        name: q,
        acceptedAnswer: { "@type": "Answer", text: a },
      })),
    },
  };

  return (
    <>
      <Helmet>
        <title>
          Rankridge – Intermediate, IIT-JEE & NEET | Hyderabad’s Trusted College
        </title>
        <meta
          name="description"
          content="Rankridge: Intermediate (MPC/BiPC), IIT-JEE & NEET coaching with top faculty, weekly exams, personal mentorship, safe campus, and proven results."
        />
        <link rel="canonical" href={brand.url} />
      </Helmet>

      {/* Structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd.org) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd.website) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd.breadcrumb) }}
      />
      {jsonLd.courses.map((c, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(c) }}
        />
      ))}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd.faq) }}
      />

  


      <main id="content">
          <BannerCarouselWithCourses />
          
 <CourseGrid />
         
        {/* Why Choose + Form */}
        <section
          id="why"
          aria-labelledby="why-title"
          className="py-1 md:py-1 bg-[#cceeee] px-4 "
        >
          <div className="mx-auto max-w-7xl px-1 md:px-28  grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h2 id="why-title" className="text-2xl md:text-3xl font-bold">
                Why choose {brand.name}?
              </h2>
              <ul className="mt-6 space-y-3 text-neutral-700">
                {[
                  "India’s top faculty with personal mentorship",
                  "Weekly exams + analytics, monthly parent reviews",
                  "Stress-free learning with small batches",
                  "Hygienic food, safe hostels, GPS-enabled buses",
                  "AI-assisted doubt clearing & digital tracking",
                 ' Consistent top ranks in IIT-JEE, NEET & EAMCET every year',

'National-level faculty from IITs, NITs & AIIMS backgrounds',

'Rankridge Smart Method (RSM®) for exam-focused learning',
'Modern labs for Physics, Chemistry, Biology & Mathematics',
'Regular parent-teacher reviews & transparent updates'


                ].map((p) => (
                  <li key={p} className="flex items-center gap-3">
                    <span className="mt-1 h-2 w-2 rounded-full bg-teal-600" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>

            <aside
              id="enquiry"
              aria-label="Enquiry form"
              className="rounded-2xl bg-white ring-1 ring-neutral-200 p-6"
            >
              <form
                className="grid gap-4"
                onSubmit={(e) => {
                  e.preventDefault();
                  alert("Form submitted (wire to your API)");
                }}
              >
                <h3 className="text-lg font-semibold">Get a Free Counselling Call</h3>
                <label className="grid gap-1">
                  <span className="text-sm">Full Name</span>
                  <input
                    required
                    name="name"
                    className="rounded-xl ring-1 ring-neutral-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                    placeholder="Your name"
                  />
                </label>
                <label className="grid gap-1">
                  <span className="text-sm">Phone</span>
                  <input
                    required
                    name="phone"
                    inputMode="tel"
                    className="rounded-xl ring-1 ring-neutral-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                    placeholder="+91-"
                  />
                </label>
                <label className="grid gap-1">
                  <span className="text-sm">Program</span>
                  <select
                    name="program"
                    className="rounded-xl ring-1 ring-neutral-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                  >
                    <option>Intermediate (MPC)</option>
                    <option>Intermediate (BiPC)</option>
                    <option>IIT-JEE</option>
                    <option>NEET</option>
                  </select>
                </label>
                <button
                  type="submit"
                  className="rounded-xl bg-teal-600 px-4 py-2 text-white font-semibold hover:bg-teal-700"
                >
                  Request Call
                </button>
                <p className="text-xs text-neutral-500">
                  By submitting, you agree to our terms & privacy policy.
                </p>
              </form>
            </aside>
          </div>
        </section>

        {/* Rank Advantages (cards grid) */}
        <section id="advantages" aria-labelledby="adv-title" className="py-2 md:py-2 ">
           <FeatureCards />
        </section>

        

        {/* Recent Blogs + Reviews */}
        <section id="blogs" aria-labelledby="blog-title" className="py-1 md:py-1 bg-[#cceeee]">
          <div className="mx-auto  px-4 ">
            <div className="lg:col-span-2">
              <h2 id="blog-title" className="text-2xl md:text-3xl text-center font-bold">Recent Blogs</h2>
              <div className="mt-6 grid gap-4 sm:grid-cols-2">
                {[1, 2, 3, 4].map((i) => (
                  <article key={i} className="rounded-2xl bg-white ring-1 ring-neutral-200 p-5 hover:ring-teal-300">
                    <h3 className="font-semibold">How to plan a perfect NEET year {i}</h3>
                    <p className="mt-2 text-sm text-neutral-600">
                      Weekly targets, revision loops, and test strategies that work.
                    </p>
                    <a href={`/blog/neet-plan-${i}`} className="mt-4 inline-block text-teal-700 font-medium">Read more →</a>
                  </article>
                ))}
              </div>
            </div>

            <aside aria-labelledby="reviews-title" className="lg:col-span-1 mt-4 mb-4">
             <Testimonials />
            
             
            </aside>
          </div>
        </section>

        {/* FAQ */}
         <RankridgeFAQTease />
      </main>

     
    </>
  );
}
